var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02187 0C8.85938 0 10.6094 0.7 12.0094 2.0125C13.3219 3.4125 14.0219 5.1625 14.0219 7C14.0219 8.8375 13.3219 10.5875 12.0094 11.9875C10.6094 13.3 8.85938 14 7.02187 14C5.18437 14 3.43438 13.3 2.03437 11.9C-0.678125 9.1875 -0.678125 4.725 2.03437 2.0125C3.43438 0.7 5.18437 0 7.02187 0ZM7.02187 13.125C8.68437 13.125 10.1719 12.5125 11.3969 11.375C12.5344 10.15 13.1469 8.6625 13.1469 7C13.1469 5.3375 12.5344 3.85 11.3969 2.7125C10.1719 1.4875 8.68437 0.875 7.02187 0.875C5.35937 0.875 3.87187 1.4875 2.64687 2.625C0.284375 5.075 0.284375 8.925 2.64687 11.375C3.87187 12.5125 5.35937 13.125 7.02187 13.125Z",
    fill: "#CCCCCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89697 10.2375H7.45947V6.125C7.45947 5.8625 7.28447 5.6875 7.02197 5.6875H6.14697C5.88447 5.6875 5.70947 5.8625 5.70947 6.125C5.70947 6.3875 5.88447 6.5625 6.14697 6.5625H6.67197V10.2375H6.14697C5.88447 10.2375 5.70947 10.4125 5.70947 10.675C5.70947 10.9375 5.88447 11.1125 6.14697 11.1125H7.89697C8.15947 11.1125 8.33447 10.9375 8.33447 10.675C8.33447 10.4125 8.15947 10.2375 7.89697 10.2375Z",
    fill: "#CCCCCB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15928 3.8499C8.15928 4.4624 7.63428 4.9874 7.02178 4.9874C6.40928 4.9874 5.88428 4.5499 5.88428 3.8499C5.88428 3.1499 6.40928 2.7124 7.02178 2.7124C7.63428 2.7124 8.15928 3.2374 8.15928 3.8499ZM7.3717 3.7624C7.3717 3.5874 7.1967 3.4124 7.0217 3.4124C6.8467 3.4124 6.6717 3.5874 6.6717 3.7624C6.6717 3.9374 6.8467 4.1124 7.0217 4.1124C7.1967 4.1124 7.3717 3.9374 7.3717 3.7624Z",
    fill: "#CCCCCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ebb70e9d3a7d6bf59f11b6e4740414b0.svg";
export { ForwardRef as ReactComponent };